import React, { useEffect, useState } from "react";
import { areas } from "./area";
import styles from "./Edit.module.scss"
import { NovaSkill, RemoverSkill } from "../../Controllers/SkillController";
import { v4 as uuid } from "uuid";
import { onValue, ref } from "firebase/database";
import { db } from "../../db";
import { ISkills } from "../../Interfaces/ISkills";
import { useAuth } from "../../Contexts/AuthContext";

export default function Edit() {
  const [ID, setID] = useState(uuid());
  const [skill, setSkill] = useState("");
  const [area, setArea] = useState("");
  const [skillList,setSkillList] = useState("")
  const [lista, setList] = useState<ISkills[]>([]);
  const {logout} = useAuth()

  useEffect(() => {
    const refSkills = ref(db,'skills')
    onValue(refSkills, result => {
        const resultSkill = Object.entries<ISkills>(result.val() ?? {})
        .map(([key,value]) => {
          return {
            'ID':key,
            'skill':value.skill,
            'area':value.area
          }
        })
        setList(resultSkill)
    })
  },[])

  function EnviarSkill(event:React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (area.length < 0 || null) {
      alert("Preencha o campo Area primeiro");
    } else {
      NovaSkill({ID, skill, area});
      window.alert("Skill criada");
      setSkill("");
      setID(uuid());
      setArea("");
    }
  }

  const sair = () => {logout()}

  return (
    <div className={styles.adminContainer}>
      <div className={styles.content}>
        <div className={styles.criarSkill}>
          <h1>Nova Skill</h1>
          <form onSubmit={EnviarSkill}>
            <div>
              <p>Nome da Skill: </p>
              <input
                type="text"
                placeholder="Insira o nome da sua nova Skill"
                value={skill}
                onChange={(event) => setSkill(event.target.value)}
              />
            </div>
            <div>
              <p>Area da Skill: </p>
              <select
                value={area}
                onChange={(event) => setArea(event.target.value)}
              >
                <option value="" />
                {areas.map((item) => (
                  <option key={item.ID}>{item.area}</option>
                ))}
              </select>
            </div>
            <div>
              <button className={styles.buttom}>Criar</button>
            </div>
          </form>
        </div>

        <div className={styles.apagarSkill}>
          <h1>Apagar Skill</h1>
          <form>
            <div>
              <select value={skillList} onChange={(event) => setSkillList(event.target.value)}>
              <option value={"null"}>Escolha uma Skill para apagar</option>
              {lista?.map((item) => (
                <option key={item.ID} value={item.ID}>{item.skill}</option>
              ))}
              </select>
            </div>
            <div>
              <button className={styles.buttom} onClick={(event) => {
                if(skillList !== "null"){
                  event.preventDefault()
                  RemoverSkill(skillList)
                }

              }}>Apagar</button>
            </div>
          </form>
        </div>
        <button className={`${styles.buttom} ${styles.sair} `} onClick={sair}>Sair</button>
      </div>
    </div>
  );
}
